import { RootState } from 'src/redux/store';
import { IFileManager } from 'src/types/file';

// Data selectors
export const selectData = (state: RootState) => state.data.data;
export const selectFilteredData = (state: RootState) => state.data.filteredData;
export const selectSelectedCompanyIds = (state: RootState) => state.data.selectedCompanyIds;
export const selectInvitations = (state: RootState) => state.data.invitations;
export const selectDataLoading = (state: RootState) => state.data.loading;
export const selectDataError = (state: RootState) => state.data.error;

// Transfers selectors
export const selectTransfers = (state: RootState) => state.transfers.transfers;
export const selectLocalBeneficiaries = (state: RootState) => state.transfers.localBeneficiaries;
export const selectForeignBeneficiaries = (state: RootState) => state.transfers.foreignBeneficiaries;
export const selectTransfersLoading = (state: RootState) => state.transfers.loading;
export const selectTransfersError = (state: RootState) => state.transfers.error;

// Cautions selectors
export const selectProjects = (state: RootState) => state.cautions.projects;
export const selectGuarantees = (state: RootState) => state.cautions.guarantees;
export const selectFiles = (state: RootState): IFileManager[] => state.cautions.guarantees.flatMap((guarantee) => guarantee.documents || []);  
export const selectCautionsLoading = (state: RootState) => state.cautions.loading;
export const selectCautionsError = (state: RootState) => state.cautions.error;